import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const CalendarIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <path
                // eslint-disable-next-line max-len
                d="M17 12H12V17H17V12ZM16 1V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H18V1H16ZM19 19H5V8H19V19Z"
                fill="#21006E"
            />
        </SvgIcon>
    );
};
